import {graphql} from 'react-relay';

export const QuoteDesignerPageQuery = graphql`
	query QuoteDesignerPageQuery($projectId: String) {
		viewer {
			actualPersonId
			component(name: "baseline_quote_designer")
			project(id: $projectId) {
				id
			}
			...QuoteDesignerPage_viewer @arguments(projectId: $projectId)
		}
	}
`;
